import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslationEntry } from '@app/shared/models/translatable';
import { CaseResultValues, ResultValues, VatCalculationEnum } from '@app/shared/models/case-result';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { BasePatchComponent } from '@app/shared/components/base/base-patch.component';
import { AdditionsResultsUriBuilderParams, AdditionsResultService } from '@app/core/services/result/additions-result.service';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { MatLegacyFormField as MatFormField } from '@angular/material/legacy-form-field';


@Component({
    selector: 'results-further',
    templateUrl: './results-further.component.html',
    styleUrls: ['./results-further.component.scss']
})
export class ResultsFurtherComponent extends BasePatchComponent<CaseResultValues, AdditionsResultsUriBuilderParams>
                                     implements OnInit {

    protected paramsIdNames = ['id'];

    private _availableResultTypes: TranslationEntry[];

    @ViewChild('mffResultType', { static: true })
    public mffResultType: MatFormField;

    @ViewChild('mffGroup')
    private mffGroup: MatFormField;

    @ViewChild('mffNet')
    private mffNet: MatFormField;

    @ViewChild('mffTax')
    private mffTax: MatFormField;

    @ViewChild('mffGross', { static: true })
    private mffGross: MatFormField;

    @ViewChild('mffComment', { static: true })
    private mffComment: MatFormField;

    @Input()
    set availableResultTypes(types: TranslationEntry[]) {
        this._availableResultTypes = types;
        this.generateAvailableResultTypesAndMine();
    }

    @Input()
    public allResultTypes: TranslationEntry[];

    @Input()
    public vehicleTaxPercentage: number;

    @Output()
    public remove = new EventEmitter<CaseResultValues>();

    public selectedResultType: TranslationEntry;

    public availableResultTypesAndMine: TranslationEntry[];

    get focused() {
        return (this.mffResultType && this.mffResultType._control.focused) ||
               (this.mffGroup && this.mffGroup._control.focused) ||
               (this.mffNet && this.mffNet._control.focused) ||
               (this.mffTax && this.mffTax._control.focused) ||
               (this.mffGross && this.mffGross._control.focused) ||
               (this.mffComment && this.mffComment._control.focused);
    }

    get result() {
        return this.updated;
    }

    get resultTitle(): string {
        return this.result && this.result.result_type_id && this.allResultTypes.find(type => type.key === this.result.result_type_id) ?
                    this.allResultTypes.find(type => type.key === this.result.result_type_id).trans :
                    marker('detailed_processing.results.title.result');
    }

    get caseId() {
        return this.id;
    }

    get VatCalculationEnum() {
        return VatCalculationEnum;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected additionsResultService: AdditionsResultService) {
        super(componentServiceBundle, additionsResultService);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.generateAvailableResultTypesAndMine();
    }

    private generateAvailableResultTypesAndMine(): void {
        if (this._availableResultTypes && this.allResultTypes) {
            const types = Object.assign([], this._availableResultTypes);

            if (this.result.result_type_id) {
                const selectedType = this.allResultTypes.find(type => type.key === this.result.result_type_id);
                types.unshift(selectedType);
                this.selectedResultType = selectedType;
            }

            this.availableResultTypesAndMine = types;
        }
    }

    public getToolTip(taxType: VatCalculationEnum): string {
        return ResultValues.getNetGrossCalculationTooltip(this.vehicleTaxPercentage, taxType, this.result.net, this.result.gross);
    }

    public calculate(path: string, from: string): void {
        const opData = [{
            op: OP.copy,
            path: path,
            from: from,
        }];

        this.patchOpDataArray(opData);
    }

    public onResultTypeChange(): void {
        const opData: OpData[] = [{
            op: OP.replace,
            path: `result_type_id`,
            value: this.selectedResultType.key
        }, {
            op: OP.replace,
            path: `result_type`,
            value: this.translateService.instant(this.selectedResultType.trans)
        }];

        this.patchOpDataArray(opData);
    }

    public removeFurtherResult(): void {
        this.showSimpleConfirmDialog(
                marker('common.dialog.delete.title'),
                this.translateService.instant(marker('common.dialog.delete.text'), { 'name': this.translateService.instant(marker(this.resultTitle)) }))
            .subscribe(result => {
                if (result) {
                    this.additionsResultService.delete(this.generateUriBuilderParams())
                                            .subscribe(() => {
                        this.remove.emit(this.result);
                    });
                }
        });
    }

    protected generateUriBuilderParams(): AdditionsResultsUriBuilderParams {
        return new AdditionsResultsUriBuilderParams(this.caseId, this.original);
    }

}
